// extracted by mini-css-extract-plugin
export var section = "hero-module--section--2H4hk";
export var inner = "hero-module--inner--BH4tL";
export var content = "hero-module--content--s8XZ4";
export var pageName = "hero-module--pageName--3pMNS";
export var title = "hero-module--title--2RZgJ";